module.exports = __webpack_public_path__ + "img/knowUsRightBg.2f02d7d2.png";